export class InstantRestorePromotionWindow {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cronExpression",
            "baseName": "cronExpression",
            "type": "string",
            "format": ""
        },
        {
            "name": "durationMinutes",
            "baseName": "durationMinutes",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return InstantRestorePromotionWindow.attributeTypeMap;
    }
    constructor() {
    }
}
